// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1PTM2","clip-and-name":"style_clip-and-name__2zOz0","remove-btn":"style_remove-btn__3nG7S","doc-name":"style_doc-name__1WXuc"};